import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "text-gray-300"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex justify-content-between" }
const _hoisted_7 = {
  key: 0,
  class: "ml-2 text-xs text-teal-300"
}
const _hoisted_8 = {
  key: 1,
  class: "ml-2 text-xs text-pink-300"
}
const _hoisted_9 = {
  key: 2,
  class: "ml-2 text-xs text-gray-300"
}
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = { class: "p-fluid" }
const _hoisted_16 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueDataTable = _resolveComponent("PrimeVueDataTable")!
  const _component_PrimeVueCalendar = _resolveComponent("PrimeVueCalendar")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoCompleteMultiple = _resolveComponent("FieldDropdownAutoCompleteMultiple")!
  const _component_FiltersSidebar = _resolveComponent("FiltersSidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: `${_ctx.$t('chains_diff')} 👨‍🏫`,
      "show-refresh-button": _ctx.chainsDiffFetched,
      "refresh-button-loading": _ctx.chainsDiffLoading,
      "refresh-button-handler": _ctx.fetchchainsDiffWrapper,
      "show-filters-button": "",
      "show-filters": _ctx.showFilters,
      "onUpdate:showFilters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showFilters) = $event))
    }, null, 8, ["title", "show-refresh-button", "refresh-button-loading", "refresh-button-handler", "show-filters"]),
    (_ctx.chainsDiffLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          })
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_PrimeVueDataTable, {
            value: _ctx.chainsDiff.data,
            "responsive-layout": "scroll",
            "striped-rows": "",
            "sort-field": "feeds_payout_sum",
            "sort-order": -1
          }, {
            default: _withCtx(() => [
              (_ctx.filters.column_name.includes('endpoint_id'))
                ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                    key: 0,
                    header: "Endpoint ID",
                    field: "endpoint_id",
                    sortable: ""
                  }, {
                    body: _withCtx(({ data }) => [
                      _withDirectives((_openBlock(), _createElementBlock("a", {
                        href: `/endpoints/${data.endpoint_id}`,
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(data.endpoint_id), 1)
                      ], 8, _hoisted_2)), [
                        [
                          _directive_tooltip,
                          _ctx.chainsDiff.endpoints_map[data.endpoint_id],
                          void 0,
                          { right: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.filters.column_name.includes('feed_id'))
                ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                    key: 1,
                    header: "Feed ID",
                    field: "feed_id",
                    sortable: ""
                  }, {
                    body: _withCtx(({ data }) => [
                      _withDirectives((_openBlock(), _createElementBlock("a", {
                        href: `/feeds/${data.feed_id}`,
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(data.feed_id), 1)
                      ], 8, _hoisted_3)), [
                        [
                          _directive_tooltip,
                          _ctx.chainsDiff.feeds_map[data.feed_id],
                          void 0,
                          { right: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.filters.column_name.includes('country_id'))
                ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                    key: 2,
                    header: "Country",
                    field: "country_id",
                    sortable: ""
                  }, {
                    body: _withCtx(({ data }) => [
                      (!data.country_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "—"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.chainsDiff.countries_map[data.country_id]), 1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_PrimeVueColumn, {
                header: "Feeds $",
                field: "feeds_payout_sum",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.$n(data.feeds_payout_sum, 'payout')), 1)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chainsDiff.dates, (date, index) => {
                return (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: index,
                  header: date,
                  field: `days.${index}.diff`,
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$n(data.days[index].feeds_payout, 'payout')), 1),
                      _createElementVNode("div", null, [
                        (data.days[index].diff > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+" + _toDisplayString(data.days[index].diff) + "%", 1))
                          : _createCommentVNode("", true),
                        (data.days[index].diff < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(data.days[index].diff) + "%", 1))
                          : _createCommentVNode("", true),
                        (data.days[index].diff === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "—%"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["header", "field"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])),
    _createVNode(_component_FiltersSidebar, {
      visible: _ctx.showFilters,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showFilters) = $event)),
      "apply-button-handler": _ctx.fetchchainsDiffWrapper,
      "apply-button-loading": _ctx.chainsDiffLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Period", -1)),
            _createVNode(_component_PrimeVueCalendar, {
              modelValue: _ctx.filtersDatePeriod,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtersDatePeriod) = $event)),
                _ctx.onFiltersDatePeriodChange
              ],
              "selection-mode": "range",
              "manual-input": false,
              "show-button-bar": ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.filters.project_id,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.project_id) = $event)),
              _ctx.onProjectChange
            ],
            label: _ctx.$t('project'),
            loading: _ctx.projectsLoading,
            "show-clear": "",
            options: _ctx.projects.data,
            "option-value": "id",
            "option-label": "name",
            multiple: "",
            "multiple-sort-by-value": ""
          }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FieldDropdownAutoCompleteMultiple, {
            modelValue: _ctx.filters.endpoint_id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.endpoint_id) = $event)),
            label: _ctx.$t('endpoint'),
            "api-url": "/api/v3/endpoints/options",
            "api-params": _ctx.endpointsParams,
            "option-label": "compiled_name"
          }, null, 8, ["modelValue", "label", "api-params"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.filters.country_id,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.country_id) = $event)),
            label: _ctx.$t('country'),
            loading: _ctx.countriesLoading,
            filter: "",
            options: _ctx.countries.data,
            "option-value": "id",
            "option-label": "compiled_name",
            multiple: "",
            "multiple-sort-by-value": ""
          }, null, 8, ["modelValue", "label", "loading", "options"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_FieldDropdownAutoCompleteMultiple, {
            modelValue: _ctx.filters.feed_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.feed_id) = $event)),
            label: _ctx.$t('feed'),
            "api-url": "/api/v3/feeds/options",
            "api-params": _ctx.feedsParams,
            "option-label": "compiled_name"
          }, null, 8, ["modelValue", "label", "api-params"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.filters.column_name,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.column_name) = $event)),
            label: "Columns",
            options: _ctx.columnNameOptions,
            multiple: ""
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "apply-button-handler", "apply-button-loading"])
  ], 64))
}